import { registerIntegration } from "@p0security/shared/integrations/registry";
import {
  type AnyFilterSchema,
  Registration,
} from "@p0security/shared/integrations/types";

import { AwsRdsAccesses } from "./accesses.ts";
import { AwsRdsComponents } from "./components.ts";

const AwsRdsFilters = {} as const satisfies AnyFilterSchema;
export type AwsRdsFilters = typeof AwsRdsFilters;

export const AwsRdsRegistration = Registration({
  accesses: AwsRdsAccesses,
  category: "resource",
  components: AwsRdsComponents,
  docs: { install: "aws/managed-services/aws-rds" },
  filters: AwsRdsFilters,
  itemKind: "VPC",
  label: "AWS RDS",
  logoUrl:
    "https://a.b.cdn.console.awsstatic.com/a/v1/6JW3RZSXOZ4EFR2HZBU6IIOCUZEIFKRK6JZDCUDHQVQXRMAORYWQ/icon/1d374ed2a6bcf601d7bfd4fc3dfd3b5d-c9f69416d978016b3191175f35e59226.svg",
  maturity: "ga",
  requestType: "bridge",
  useMapping: [{ use: "iam_write", component: "iam-write" }],
});

registerIntegration("aws-rds", AwsRdsRegistration);
